import BookmakerImage from '../../../../assets/onboarding/onboarding-bookmaker-image.webp';
import HowItWorksImage from '../../../../assets/onboarding/writer-how-it-works-image.webp';
import QuestionnaireImage from '../../../../assets/onboarding/writer-onboarding-questionnaire-image.webp';
import InterviewsImage from '../../../../assets/onboarding/writer-onboarding-interviews-image.webp';
import BookOutlineImage from '../../../../assets/onboarding/writer-onboarding-book-outline-image.webp';
import DraftToolImage from '../../../../assets/onboarding/onboarding-draft-tool-image.webp';
import CommingSoonImage from '../../../../assets/onboarding/onboarding-comming-soon-image.webp';
import { ROUTES } from '../../../router';

/* TODO
  add video links - videoHref - when thay will be ready
*/
const translationOptions = { ns: i18next.Namespace.COMMON };

const getWriterOnboardingContent = () => ([
  {
    id: 0,
    image: BookmakerImage,
    text: t('onboarding.writer.bookmaker.description', translationOptions),
    videoLinkText: '', // Watch a video to see details.
    videoHref: '',
    email: '',
    navTitle: t('onboarding.writer.bookmaker.name', translationOptions),
    title: t('onboarding.writer.bookmaker.title', translationOptions),
    isChecked: false,
    correspondingRoutes: [],
  },
  {
    id: 1,
    image: HowItWorksImage,
    text: t('onboarding.writer.profileSetUp.description', translationOptions),
    videoLinkText: '', // Watch a video to see details.
    videoHref: '',
    email: '',
    navTitle: t('onboarding.writer.profileSetUp.name', translationOptions),
    title: t('onboarding.writer.profileSetUp.title', translationOptions),
    isChecked: false,
    correspondingRoutes: [],
  },
  {
    id: 2,
    image: QuestionnaireImage,
    text: t('onboarding.writer.questionnaire.description', translationOptions),
    videoLinkText: '', // Watch a video to see details.
    videoHref: '',
    email: '',
    navTitle: t('onboarding.writer.questionnaire.name', translationOptions),
    title: t('onboarding.writer.questionnaire.title', translationOptions),
    isChecked: false,
    correspondingRoutes: [ROUTES.projects.questionnaire.answers.path],
  },
  {
    id: 3,
    image: InterviewsImage,
    text: t('onboarding.writer.interviews.description', translationOptions),
    videoLinkText: '', // Watch a video to see details.
    videoHref: '',
    email: '',
    navTitle: t('onboarding.writer.interviews.name', translationOptions),
    title: t('onboarding.writer.interviews.title', translationOptions),
    isChecked: false,
    correspondingRoutes: [ROUTES.projects.interviews.byProjectId.path],
  },
  {
    id: 4,
    image: BookOutlineImage,
    text: t('onboarding.writer.bookOutline.description', translationOptions),
    videoLinkText: '', // Watch a video to see details.
    videoHref: '',
    email: '',
    navTitle: t('onboarding.writer.bookOutline.name', translationOptions),
    title: t('onboarding.writer.bookOutline.title', translationOptions),
    isChecked: false,
    correspondingRoutes: [ROUTES.projects.outline.byProjectId.path],
  },
  {
    id: 5,
    image: DraftToolImage,
    text: t('onboarding.writer.draft.description', translationOptions),
    videoLinkText: '',
    videoHref: '',
    email: '',
    navTitle: t('onboarding.writer.draft.name', translationOptions),
    title: t('onboarding.writer.draft.title', translationOptions),
    isChecked: false,
    correspondingRoutes: [ROUTES.projects.draft.byProjectId.path],
  },
  {
    id: 6,
    image: CommingSoonImage,
    text: t('onboarding.writer.commingSoon.description', translationOptions),
    videoLinkText: '',
    videoHref: '',
    email: 'feedback@storyterrace.com',
    navTitle: t('onboarding.writer.commingSoon.name', translationOptions),
    title: t('onboarding.writer.commingSoon.title', translationOptions),
    isChecked: false,
    correspondingRoutes: [],
  },
]);

export default getWriterOnboardingContent;
